import React, { useEffect, useRef } from "react";
import "../styles/About-2.css";
import gridImg from "../assets/images/serene-about-2.webp";
import { motion, useInView, useMotionValue, animate } from "framer-motion";



function CountUp({ value, duration = 1 }) {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: false, amount: 0.4 });
    const motionValue = useMotionValue(0);
    const [display, setDisplay] = React.useState(0);

    useEffect(() => {
        const unsubscribe = motionValue.on("change", (latest) => {
            setDisplay(latest.toFixed(0));
        });

        return unsubscribe;
    }, [motionValue]);

    useEffect(() => {
        if (isInView) {
            const controls = animate(motionValue, value, {
                duration,
                ease: "easeOut",
            });

            return controls.stop;
        } else {
            motionValue.set(0); // reset when leaving viewport
        }
    }, [isInView, value, duration, motionValue]);

    return <span ref={ref}>{display}</span>;
}

// ✅ Bottom → Top + fade + blur (premium)
const fadeUp = {
    hidden: { opacity: 0, y: 45, filter: "blur(10px)" },
    show: {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        transition: { duration: 0.9, ease: "easeOut" },
    },
};

const wordContainer = {
    hidden: {},
    show: {
        transition: {
            staggerChildren: 0.12,
            delayChildren: 0.2,
        },
    },
};

const wordVariant = {
    hidden: {
        y: 40,
        opacity: 0,
        filter: "blur(6px)",
    },
    show: {
        y: 0,
        opacity: 1,
        filter: "blur(0px)",
        transition: {
            duration: 0.9,
            ease: "easeOut",
        },
    },
};

// ✅ split title words
// ✅ remove starting space also
const line1 = "Welcome to".split(" ");
const line2 = "Serene Living".split(" ");




export default function About2() {


    return (
        <section className="about2-section">
            <div className="container">


                {/* Top Heading */}
                <div className="row mb-5">


                    <div className="col-lg-7 d-flex align-items-center mt-4 mt-lg-0">

                        <motion.h2
                            className="sage-title display-4"
                            variants={wordContainer}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: false, amount: 0.6 }}
                        >
                            {line1.map((word, i) => (
                                <motion.span
                                    key={`line1-${i}`}
                                    variants={wordVariant}
                                    style={{ display: "inline-block", marginRight: "0.35em" }}
                                >
                                    {word}
                                </motion.span>
                            ))}

                            <br />

                            {line2.map((word, i) => (
                                <motion.span
                                    key={`line2-${i}`}
                                    variants={wordVariant}
                                    style={{ display: "inline-block", marginRight: "0.35em" }}
                                >
                                    {word}
                                </motion.span>
                            ))}
                        </motion.h2>

                    </div>
                    <div className="col-lg-5 d-flex justify-content-center flex-column">


                        <motion.p className="about-text mb-0" variants={fadeUp}>
                            Serene offers a curated range of lifestyle amenities designed to enrich everyday living with comfort and sophistication. From serene green spaces to thoughtfully crafted leisure areas, every amenity enhances a life of balance and elegance.
                        </motion.p>
                    </div>
                </div>

                {/* GRID */}
                <div className="about2-grid-wrapper">

                    {/* ROW 1 */}
                    <div className="row g-0">
                        {/* 15+ */}
                        <div className="col-md-3">
                            <div className="about2-box border-r border-b">
                                <h3 className="about2-number">  <CountUp value={12} /></h3>
                                <p className="about2-caption">
                                    Acres
                                </p>
                            </div>
                        </div>

                        {/* empty box */}
                        <div className="col-md-3">
                            <div className="about2-box border-r border-b no-top-border"></div>
                        </div>


                        {/* image - IMPORTANT: NO BOX border */}
                        <div className="col-md-3">
                            <div className="about2-imgHolder border-b">
                                <img src={gridImg} alt="grid" />
                            </div>
                        </div>

                        {/* 5+ */}
                        <div className="col-md-3">
                            <div className="about2-box border-b">
                                <h3 className="about2-number"> <CountUp value={85} /></h3>
                                <p className="about2-caption">
                                    Villas
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* ROW 2 */}
                    <div className="row g-0">
                        {/* 95% */}
                        <div className="col-md-3">
                            <div className="about2-box border-r">
                                <h3 className="about2-number"> <CountUp value={4} /> & <CountUp value={5} /></h3>
                                <p className="about2-caption">
                                    BHKs
                                </p>
                            </div>
                        </div>

                        {/* 100+ */}
                        <div className="col-md-3">
                            <div className="about2-box border-r">
                                <h3 className="about2-number">Narsingi</h3>
                                <p className="about2-caption">Located in the serene and fast-growing Narsingi locale</p>
                            </div>
                        </div>

                        <div className="col-md-6 no-right-bottom-border d-flex justify-content-end align-items-end">
                            <div className="about2-paragraph">
                                A thoughtfully planned enclave set abundant greenery, where contemporary homes are woven into the natural landscape. Designed privacy harmony, and connection, it’s a community  expansive and deeply personal every day.
                            </div>
                        </div>



                    </div>
                </div>

            </div>
        </section>
    );
}
